import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeLibrary } from '@/mocks/animeData';

export default function RankingSection() {
  const ranking = animeLibrary
    .filter((item) => typeof item.weeklyRank === 'number')
    .sort((a, b) => (a.weeklyRank ?? 0) - (b.weeklyRank ?? 0));

  return (
    <section id="ranking" className="w-full py-16 md:py-24">
      <div className="px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              eyebrow="Weekly Ranking"
              title="本周热播榜"
              description="按近期讨论热度排列的六部作品，卡片标出更新进度与本期看点，没想好看什么时从这里挑最省事。"
            />
            <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
              数据按本期整理结果展示
            </span>
          </div>
        </Reveal>

        <div className="mt-10 space-y-3 md:space-y-4">
          {ranking.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group flex gap-4 md:gap-6 rounded-lg bg-background-100 border border-background-200/70 p-3 md:p-4 hover:border-primary-300 transition-colors">
                <div className="flex-shrink-0 w-10 md:w-14 flex items-center justify-center">
                  <span
                    className={`font-heading text-2xl md:text-4xl font-black ${
                      index === 0 ? 'text-primary-500' : 'text-foreground-300'
                    }`}
                  >
                    {(item.weeklyRank ?? index + 1).toString().padStart(2, '0')}
                  </span>
                </div>

                <div className="flex-shrink-0 w-16 h-24 md:w-20 md:h-28 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title} 动漫作品封面`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <span className="px-2 py-0.5 rounded-full text-[11px] md:text-xs bg-secondary-100 text-secondary-900">
                        {item.genre}
                      </span>
                      <span
                        className={`px-2 py-0.5 rounded-full text-[11px] md:text-xs ${
                          item.status === '更新中'
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        {item.status}
                      </span>
                    </div>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {item.summary}
                    </p>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500 hidden sm:block">
                      <i className="ri-lightbulb-line text-accent-600 mr-1"></i>
                      看点：{item.highlight}
                    </p>
                  </div>

                  <div className="mt-3 flex items-center gap-4">
                    <div className="flex items-center gap-1 text-xs md:text-sm text-foreground-700">
                      <i className="ri-star-fill text-accent-500"></i>
                      <span className="font-medium">{item.score}</span>
                    </div>
                    <div className="flex items-center gap-1 text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      <i className="ri-time-line"></i>
                      {item.episodes}
                    </div>
                    <div className="hidden md:flex items-center gap-2 flex-1 max-w-[180px]">
                      <div className="flex-1 h-1.5 rounded-full bg-background-300 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                          style={{ width: `${item.heat ?? 60}%` }}
                        ></div>
                      </div>
                      <span className="text-xs text-foreground-500">{item.heat}</span>
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}